import { Component, Renderer2, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { PageBaseComponent, PITEventService, UtilsMisc } from '@pit/core';
import { AppMode, IPinItTrackFrontendApplicationService, PinItTrackFrontendServicesAccessor } from '@pit/frontend-shared';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'pit-track-web-app-main-page',
    templateUrl: './pin.it.track.web.app.main.page.component.html',
    styleUrls: ['./pin.it.track.web.app.main.page.component.scss']
})
export class PinItTrackWebAppMainPageComponent extends PageBaseComponent implements AfterContentChecked {

    constructor(private readonly servicesAccessor: PinItTrackFrontendServicesAccessor, private renderer: Renderer2,
        private confirmationService: ConfirmationService, private messageService: MessageService, private eventService: PITEventService,
        private cdr: ChangeDetectorRef, private router: Router, private activatedRoute: ActivatedRoute) {
        super(servicesAccessor.coreServicesAccessor.applicationService);

        this.applicationServiceExt = this.servicesAccessor.coreServicesAccessor.applicationService;

        this.eventService.subscribeForEvent('confirmation', this.handleEventConfirmationAsync.bind(this));
        this.eventService.subscribeForEvent('message', this.handleEventMessageAsync.bind(this));

        this.loggingService.debug('PITTrackWebAppMainPageComponent');
    }

    public readonly applicationServiceExt: IPinItTrackFrontendApplicationService = null;

    public isAppModeGuest: boolean = (this.servicesAccessor.coreServicesAccessor.applicationService.appMode === AppMode.Guest);

    public isBusy$: Observable<boolean> = this.servicesAccessor.coreServicesAccessor.applicationService.isBusy$;

    // Names the current area for the visually hidden main heading, so screen readers
    // get a document structure. Sighted users see no change.
    public areaHeading: string = 'PIN Track ADMIN';

    protected override async doOnAfterViewInitAsync(): Promise<void> {
        await this.applicationServiceExt.initializeAsync();

        // Set once up front: the first NavigationEnd happens before this subscription.
        this.updateAreaHeading();

        this.subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => this.updateAreaHeading()));

        this.applicationServiceExt.setRenderer(document, this.renderer);

        /*window.onbeforeunload = function (e) {
            e = e || window.event;

            // For IE and Firefox prior to version 4
            if (e) {
                e.returnValue = 'Sure?';
            }

            // For Safari
            return 'Sure?';
        };*/
    }

    protected override async doOnInitAsync(): Promise<void> {
        await super.doOnInitAsync();
    }

    ngAfterContentChecked(): void {
        this.cdr.detectChanges();
    }

    private updateAreaHeading(): void {
        let route: ActivatedRoute = this.activatedRoute;
        while (route.firstChild) {
            route = route.firstChild;
        }
        const title: string = route.snapshot.data ? route.snapshot.data['title'] : null;
        this.areaHeading = (title ? title : 'PIN Track ADMIN');
    }

    private async handleEventConfirmationAsync(confirmationData: any): Promise<void> {
        if ((UtilsMisc.isNullOrUndefined(confirmationData) === false) && (UtilsMisc.isNullOrUndefined(confirmationData.callback) === false) &&
            (UtilsMisc.isNullOrUndefined(confirmationData.callback.method) === false)) {
            this.confirmationService.confirm({
                message: confirmationData.message,
                header: confirmationData.header,
                icon: confirmationData.icon,
                acceptLabel: confirmationData.acceptLabel,
                rejectLabel: confirmationData.rejectLabel,
                accept: async () => {
                    await confirmationData.callback.method(true, confirmationData.callback.data);
                },
                reject: async () => {
                    await confirmationData.callback.method(false, confirmationData.callback.data);
                }
            });
        }
    }

    private async handleEventMessageAsync(messageData: any): Promise<void> {
        this.messageService.add({ 
            severity: messageData.severity, 
            summary: messageData.summary, 
            detail: messageData.detail,
            sticky: messageData.sticky || false,
            life: messageData.life || 3000
        });
    }

}
